<script> // FIXME: ts issues
import store from '@/store'
import {computed, ref} from "vue";
import QualityChecks from "@/components/QualityChecks/QualityChecks.vue";
import {Tab, Tabs} from "@/components/Controls/Tabs";
import Classifiers from "@/components/Settings/Team/Classifiers.vue";
import Policies from "@/components/Settings/Team/Policies.vue";

// need to use Vue 3 export default format because component must have explicit name option
export default {
    name: 'ContentQualityPage',
    computed: {
        store() {
            return store
        }
    },
    components: {Policies, Classifiers, QualityChecks, Tab, Tabs},
    setup() {
        const hasClassifierUpdates = ref(false);
        const features = computed(() => store.getters.accountFeatures);
        const contentPolicyEnabled = computed(() => features.value.contentPolicy);
        const hideIntegrations = computed(() => store.getters.hideIntegrations);
        const account = computed(() => store.getters.currentAccountOverview);
        // DEV-2885: `features` is accountFeatures, where an absent key reads as enabled
        // (trueIfUndef) and an explicit false hides. `thetalake` defaults to false in
        // subscriptionFeaturesDefaults, so this is off until the plan grants it.
        //
        // NOTE: the <tabs> block below is wrapped in v-if="contentPolicyEnabled", so this tab is
        // additionally invisible unless contentPolicy is on. That gating predates DEV-2843 and
        // applies to the Proofpoint tab too; flagged rather than changed here.
        const thetalakeEnabled = computed(() => features.value.thetalake);

        const handleUpdatePolicyTab = () => {
            hasClassifierUpdates.value = true;
        };

        const handleResetHasClassifierUpdates = () => {
            hasClassifierUpdates.value = false;
        }
        return {
            hasClassifierUpdates,
            contentPolicyEnabled,
            hideIntegrations,
            account,
            thetalakeEnabled,
            handleUpdatePolicyTab,
            handleResetHasClassifierUpdates,
        }
    }
}
</script>

<template>
    <div>
        <tabs v-if="contentPolicyEnabled">
            <tab label="Classifiers">
                <Classifiers @updatePolicyTab="handleUpdatePolicyTab"/>
            </tab>
            <tab label="Policies">
                <div class="Policies">
                    <Policies
                        :has-classifier-updates="hasClassifierUpdates"
                        @reset-has-classifier-updates="handleResetHasClassifierUpdates"
                    />
                </div>
            </tab>
            <tab v-if="!hideIntegrations" label="Proofpoint Tags">
                <QualityChecks :account="account" provider="proofpoint"></QualityChecks>
            </tab>
            <!-- DEV-2885: a separate tab rather than one dynamically-renamed tab (decided
                 2026-08-14) — clearer when both providers are connected. Unlike the Proofpoint
                 tab above, which gates only on !hideIntegrations and so renders regardless of
                 entitlement, this one is gated on the thetalake entitlement. Existing behaviour
                 there is not the pattern to copy. -->
            <tab v-if="thetalakeEnabled" label="Theta Lake Tags">
                <QualityChecks :account="account" provider="thetalake"></QualityChecks>
            </tab>
        </tabs>
    </div>
</template>

<style scoped>

</style>
